import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const PageTitle = styled.span`
  align-self: flex-start;
  font-family: BiotifSemiBold;
  font-size: 28px;
  padding-bottom: 10px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  gap: 15px;
  @media only screen and (max-width: 1000px) {
  }
`;

export const Container = styled.div`
  background-color: white;
  height: min(40vh);
  @media only screen and (max-width: 1000px) {
    grid-column-start: 1;
    grid-column-end: 3;
  }
`;

export const MessagesBulletinsContainer = styled(Container)``;

export const ProfileContainer = styled(Container)`
  display: grid;
  gap: 15px;
`;

export const EmployeeContainer = styled(Container)`
  grid-column-start: 1;
  grid-column-end: 3;
`;

export const CardContainer = styled.div`
  background-color: white;
  border-radius: 4px;
  min-height: 45vh;
  @media only screen and (max-width: 1000px) {
  }
`;
export const CardItemContainer = styled.div`
  padding: 0 20px;
  background-color: white;
  margin-bottom: 20px;
`;

export const HeaderText = styled.h3``;

export const ProfileSmallCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
  gap: 10px;
  width: 250px;
  height: 45px;
  background-color: #4948ac;
  border: 1px solid #4948ac;
`;

export const ProfileSmallCardTitle = styled.span`
  color: white;
  font-family: Biotif;
  font-size: 20px;
`;

export const ProfileSmallCardValue = styled.span`
  color: white;
  font-family: Biotif;
  font-size: 20px;
`;

export const CardFormsContainer = styled(CardItemContainer)`
  display: flex;
  width: 100%;
  padding: 0;
  column-gap: 10px;
`;

export const CardHeaderWithButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;
